import {useAccessToken, useCustomQuery} from '@salesforce/commerce-sdk-react'

const useGiftCardBalance = (cardNumberForBalance, pinForBalance, enable) => {
    const urlEncodedBody = new URLSearchParams({
        giftCertificateID: cardNumberForBalance,
        giftCertificatePin: pinForBalance,
        context: 'checkout'
    }).toString()
    const {token} = useAccessToken()

    return useCustomQuery(
        {
            options: {
                method: 'POST',
                customApiPathParameters: {
                    apiName: 'gift-cards',
                    apiVersion: 'v1',
                    endpointPath: 'giftCardBalance'
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: urlEncodedBody
            }
        },
        {
            enabled: enable
        }
    )
}

export default useGiftCardBalance
